import { render } from "./contentDsc.vue?vue&type=template&id=d1a57460&scoped=true"
import script from "./contentDsc.vue?vue&type=script&lang=js"
export * from "./contentDsc.vue?vue&type=script&lang=js"

import "./contentDsc.vue?vue&type=style&index=0&id=d1a57460&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a57460"]])

export default __exports__